import script from "./FloatingWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&setup=true&lang=js"

import "./FloatingWindow.vue?vue&type=style&index=0&id=2afcaef9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afcaef9"]])

export default __exports__